import { createRuntimeServiceAccessKey } from '../../../../../services/runtimeServices';
import { createNetworkProviderBuilderRegistry } from '../createNetworkProviderBuilderRegistry';

export const getNetworkProviderBuilderRegistry = createRuntimeServiceAccessKey(
  'networkProviderBuilderRegistry',
  createNetworkProviderBuilderRegistry
);
